import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import Wordmark from "@/components/Wordmark";
import { CONTACT } from "@/data/content";

const cols = [
  {
    title: "Services",
    links: [
      { to: "/hvac-service", label: "HVAC Service" },
      { to: "/furnace-installation", label: "Furnace Installation" },
      { to: "/ac-installation", label: "AC Installation" },
      { to: "/light-commercial-hvac", label: "Light Commercial" },
      { to: "/rtu-change-outs", label: "RTU Change-Outs" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/technology-diagnostics", label: "Technology" },
      { to: "/preventive-maintenance", label: "Maintenance" },
      { to: "/projects", label: "Projects" },
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Partners",
    links: [
      { to: "/property-managers", label: "Property Managers" },
      { to: "/contractor-partners", label: "Contractor Partners" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 bg-ink">
    <div className="blueprint-grid absolute inset-0 opacity-40" aria-hidden />
    <div className="relative mx-auto max-w-[1440px] px-6 py-20 md:px-12">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Wordmark size="text-base" />
          <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-slatex-300">
            Engineering-driven HVAC service and installation for residential and light commercial systems across Chicago.
          </p>
          <div className="mt-6 space-y-2 font-mono text-xs text-slatex-300">
            <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 hover:text-brand-cyan"><Phone size={14} weight="fill" /> {CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-brand-cyan"><EnvelopeSimple size={14} weight="fill" /> {CONTACT.email}</a>
            <span className="flex items-center gap-2"><MapPin size={14} weight="fill" /> {CONTACT.location} · {CONTACT.radius}</span>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="mb-5 font-mono text-[10px] uppercase tracking-[0.2em] text-slatex-500">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="font-body text-sm text-slatex-300 transition-colors hover:text-white">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
        <p className="font-mono text-[11px] text-slatex-500">© {new Date().getFullYear()} Genuine Forge · HVAC Contractor · Chicago, IL</p>
        <p className="font-mono text-[11px] text-slatex-500">Built Right. Diagnosed Precisely.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
